import { PositionGeocode } from '../position-geocode.entity';

export function isPositionEquals(
  position1: PositionGeocode | undefined,
  position2: PositionGeocode | undefined,
) {
  if (!position1 || !position2) {
    return false;
  }
  return (
    position1.coordinates[0] === position2.coordinates[0] &&
    position1.coordinates[1] === position2.coordinates[1]
  );
}
